import React from 'react'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'

const ErrorAddLayerModal = ({ isModalOpen, handleClose }) => {
  return (
    <AdxInfoModal
      open={isModalOpen}
      onClose={handleClose}
      handleClose={handleClose}
      muiIcon="error"
      iconColor="error.main"
      title="Please add department"
      subtitle="You need to add department before adding a new layer"
      footerButtons
      firstBtnLabel={'Cancel'}
      firstBtnHandle={handleClose}
    ></AdxInfoModal>
  )
}

export default ErrorAddLayerModal
